import {
  FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST,
  FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST,
  FETCHING_DRAFT_COURSES_FOR_STUDIO_FAILED,
  FETCHING_DRAFT_COURSES_FOR_STUDIO_SUCCEEDED,
  FETCHING_PUBLISHED_COURSES_FOR_STUDIO_FAILED,
  FETCHING_PUBLISHED_COURSES_FOR_STUDIO_SUCCEEDED,

} from "src/redux/actions/actionTypes";
import _ from "lodash";
import { DraftCourseSummary, FetchDraftCoursesResponse, FetchPublishedCoursesResponse, PublishedCourseSummary } from "src/types/coaching/courses";

interface StudioState {
  featured: DraftCourseSummary | null;
  drafts: DraftCourseItemsState;
  published: PublishedCourseItemsState;
}

interface DraftCourseItemsState {
  loading: boolean;
  items: DraftCourseSummary[];
  error: any;
  pagination: {
    currentPage: number;
    totalPages: number;
    recordsPerPage: number;
    totalRecordsCount: number;
    hasMoreItems: boolean;
  };
}

interface PublishedCourseItemsState {
  loading: boolean;
  items: PublishedCourseSummary[];
  error: any;
  pagination: {
    currentPage: number;
    totalPages: number;
    recordsPerPage: number;
    totalRecordsCount: number;
    hasMoreItems: boolean;
  };
}

const initialState: StudioState = {
  featured: null,
  drafts: {
    loading: false,
    items: [],
    error: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0,
      hasMoreItems: false,
    },
  },
  published: {
    loading: false,
    items: [],
    error: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0,
      hasMoreItems: false,
    },
  },
};

export function studioReducer(state = initialState, action: any) {
  switch (action.type) {

    case FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: true,
        },
      };
    }

    case FETCHING_DRAFT_COURSES_FOR_STUDIO_SUCCEEDED: {
      const { response } = action.payload as FetchDraftCoursesResponse;

      const existingItems: DraftCourseSummary[] = state.drafts.items;
      let featured = state.featured;

      let records = response.records || [];
      if(response.currentPage == 0) {
        featured = _.first(records) || null;
        records.shift();
      }else if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, "id");

      return {
        ...state,
        featured: featured,
        drafts: {
          ...state.drafts,
          loading: false,
          items: records,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
            hasMoreItems: response.currentPage < response.totalPages - 1,
          },
        },
      };
    }

    case FETCHING_DRAFT_COURSES_FOR_STUDIO_FAILED: {
      const error = action.payload;
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: false,
          error: error,
        },
      };
    }

    case FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST: {
      return {
        ...state,
        published: {
          ...state.published,
          loading: true,
        },
      };
    }

    case FETCHING_PUBLISHED_COURSES_FOR_STUDIO_SUCCEEDED: {
      const { response } = action.payload as FetchPublishedCoursesResponse;

      const existingItems: PublishedCourseSummary[] = state.published.items;

      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, "id");

      return {
        ...state,
        published: {
          ...state.published,
          loading: false,
          items: records,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
            hasMoreItems: response.currentPage < response.totalPages - 1,
          },
        },
      };
    }

    case FETCHING_PUBLISHED_COURSES_FOR_STUDIO_FAILED: {
      const error = action.payload;
      return {
        ...state,
        published: {
          ...state.published,
          loading: false,
          error: error,
        },
      };
    }

    default:
      return state;
  }
}
